import { render, staticRenderFns } from "./sideTablec.vue?vue&type=template&id=3e289af2&scoped=true"
import script from "./sideTablec.vue?vue&type=script&lang=js"
export * from "./sideTablec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e289af2",
  null
  
)

export default component.exports